import { IS_SERVER } from "@/common/const";
import { logServerError } from "@/util/serverErrorLogger";
import { AxiosError, AxiosHeaders } from "axios";
import { redirect } from "next/navigation";
import qs from "qs";
import { Api } from "./Api";
import { resolveBrowserZoneId } from "./zoneHeader";

const api = new Api({
  baseURL: "/",
  timeout: 30000,
});

api.instance.defaults.paramsSerializer = (params: Record<string, unknown>) => {
  return qs.stringify(params, { arrayFormat: "repeat" });
};

api.instance.interceptors.request.use((config) => {
  const headers = config.headers ?? new AxiosHeaders();
  const zoneId = resolveBrowserZoneId();

  if (zoneId) {
    headers.set("X-Zone-Id", zoneId);
  }

  return config;
});

api.instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      if (error.config?.url?.includes("/api/v1/user/profile")) {
        return Promise.resolve({
          data: null,
        });
      }

      if (IS_SERVER) {
        redirect("/login");
      } else {
        window.location.href = "/login";
      }
    }

    // 服务端详细日志记录
    if (IS_SERVER) {
      logServerError(error);
    }

    const message =
      (error.response?.data as { message?: string })?.message || error.message;

    // 在服务端，只将简化的错误信息传递给客户端
    if (IS_SERVER) {
      error.message = "Server error, please try again later.";
    } else {
      error.message = message || error.message;
    }

    return Promise.reject(error);
  }
);

export * from "./Api";
export { api };
